// КОМПОНЕНТ ПРОВЕРКИ ПРОЕКТОВ ПРЕПОДАВАТЕЛЕМ
import React, { useState, useEffect, useCallback } from 'react';
import { jwtDecode } from 'jwt-decode';
import cl from '../Jornal/Style.module.css';
import Spinner from '../../components/UI/Spinner/Spinner';
import AdminService from '../../API/AdminService';
import UserService from '../../API/UserService';
import { FOLDER_PROJECT_RT } from '../../API/API';
import { FOLDER_PROFILE } from '../../API/API';
import logger from '../../utils/logger';
import PageIntro from '../../components/PageIntro/PageIntro';
import {
    IconShieldCheck, IconRefresh, IconCheck, IconClose, IconAlert, IconClock,
    IconDiamond, IconStar, IconBook, IconUser, IconImage,
} from '../../components/Icons';

import ava from './img/1.png'

// Данные проектов роботехники
const projectRoboTehnick = [
    { id: 1, title: 'Фонарик брелок', desc: 'Схема фонарике в корпусе из 2 крышек', ratingCount: 3, diamondCount: 3 },
    { id: 2, title: 'Колесо фортуны', desc: 'Крутится диск и выпадает случайное число', ratingCount: 5, diamondCount: 5 },
    { id: 3, title: 'Игра - не касайся!', desc: 'Проведи рукой по лабиринту не касаясь его', ratingCount: 6, diamondCount: 6 },
    { id: 4, title: 'Робот жук', desc: 'Два уса, 3 колеса - катается по полу', ratingCount: 8, diamondCount: 8 },
    { id: 5, title: 'Сигнализация на герконе', desc: 'Сигнализация, которая срабатывает при разрыве магнита', ratingCount: 10, diamondCount: 10 },
    { id: 6, title: 'Сигнализация на колодке', desc: 'Сигнализация, которая срабатывает на обрыв провода', ratingCount: 10, diamondCount: 10 },
    { id: 7, title: 'Факел из майна', desc: 'Ночник - факел из майнкрафта', ratingCount: 8, diamondCount: 8 },
    { id: 8, title: 'Колонка v1', desc: 'Колонка на транзисторе по технологиям дедов', ratingCount: 10, diamondCount: 10 },
    { id: 9, title: 'Ковырялка в носу', desc: 'Светильник - мини джедайский меч', ratingCount: 10, diamondCount: 10 },
    { id: 10, title: 'Мультивибратор', desc: 'Кулон, который перемигивается на макетке', ratingCount: 12, diamondCount: 12 },
    { id: 11, title: 'Песочные часы', desc: 'Пайка на плате - электронные песочные часы', ratingCount: 14, diamondCount: 14 },
    { id: 12, title: 'Радио', desc: 'Пайка на плате - полнофункциональное мини радио', ratingCount: 16, diamondCount: 16 },
    { id: 13, title: 'Колонка v2', desc: 'Колонка на микросхеме - технологии 2010 года', ratingCount: 12, diamondCount: 12 },
    { id: 14, title: 'Игра лабиринт', desc: 'Прокати шарик по лабиринту, не попав в ловушки', ratingCount: 14, diamondCount: 14 },
    { id: 15, title: 'Колесо-кричалка', desc: 'Колесо фортуны, крутящееся пока на него кричишь', ratingCount: 12, diamondCount: 12 }
];

const AproveProject = () => {
    const [projectsForReview, setProjectsForReview] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');

    const [selectedProject, setSelectedProject] = useState(null);
    const [showDetailModal, setShowDetailModal] = useState(false);
    const [showApproveModal, setShowApproveModal] = useState(false);
    const [showRejectModal, setShowRejectModal] = useState(false);

    const [processing, setProcessing] = useState(false);
    const [successMessage, setSuccessMessage] = useState('');

    const getUserIdFromToken = useCallback(() => {
        try {
            const token = localStorage.getItem('Authorization');
            if (!token) return null;
            const decoded = jwtDecode(token);
            return decoded.id;
        } catch (error) {
            logger.error('Ошибка декодирования токена:', error);
            return null;
        }
    }, []);

    const loadProjectsForReview = useCallback(async () => {
        try {
            setLoading(true);
            setError('');

            const userId = getUserIdFromToken();
            if (!userId) {
                setError('Ошибка авторизации');
                return;
            }

            const resp = await AdminService.getRobotehnickAggregate('pending');
            if (!resp?.success) {
                setError('Не удалось загрузить аккаунты студентов');
                return;
            }

            const { accounts, students: studentsMap, minecraftia } = resp.data;

            const projectsList = [];
            for (const account of accounts) {
                const accountMinecraftUser = account.idUserMinecraftia
                    ? (minecraftia[account.idUserMinecraftia] || null)
                    : null;

                const pendingTasks = account.pendingTasks || [];

                for (const task of pendingTasks) {
                    if (!Array.isArray(task)) continue;
                    const [projectId, filename] = task;
                    const projectData = projectRoboTehnick.find(p => p.id === projectId);
                    if (!projectData) continue;

                    const student = studentsMap[account.idStudent] || {
                        id: account.idStudent,
                        firstName: 'Студент',
                        lastName: `#${account.idStudent}`,
                        age: 'неизвестно',
                        isFallback: true,
                    };

                    projectsList.push({
                        accountId: account.id,
                        projectId,
                        filename,
                        student: {
                            id: student.id,
                            firstName: student.firstName,
                            lastName: student.lastName,
                            age: student.age,
                            isFallback: !!student.isFallback,
                        },
                        minecraftUser: accountMinecraftUser ? {
                            id: accountMinecraftUser.id,
                            firstName: accountMinecraftUser.firstName || 'Неизвестно',
                            photo: accountMinecraftUser.photo || '',
                            level: accountMinecraftUser.level || 0,
                            diamonds: accountMinecraftUser.diamond || 0,
                            rating: accountMinecraftUser.rating || 0,
                        } : null,
                        project: projectData,
                        uniqueKey: `${account.id}-${projectId}-${filename}`,
                    });
                }
            }

            setProjectsForReview(projectsList);
        } catch (error) {
            logger.error('Ошибка загрузки проектов на проверку:', error);
            setError('Ошибка загрузки проектов: ' + (error?.message || error));
        } finally {
            setLoading(false);
        }
    }, [getUserIdFromToken]);

    useEffect(() => {
        loadProjectsForReview();
    }, [loadProjectsForReview]);

    const openDetailModal = useCallback((project) => {
        setSelectedProject(project);
        setShowDetailModal(true);
    }, []);

    const closeAllModals = useCallback(() => {
        setShowDetailModal(false);
        setShowApproveModal(false);
        setShowRejectModal(false);
        setSelectedProject(null);
    }, []);

    const openApproveModal = useCallback(() => {
        setShowDetailModal(false);
        setShowApproveModal(true);
    }, []);

    const openRejectModal = useCallback(() => {
        setShowDetailModal(false);
        setShowRejectModal(true);
    }, []);

    // Принятие проекта (логика сохранена)
    const approveProject = useCallback(async () => {
        if (!selectedProject) return;

        // Если minecraftUser потерян — пытаемся восстановить из списка
        if (!selectedProject.minecraftUser) {
            const projectInList = projectsForReview.find(p =>
                p.uniqueKey === selectedProject.uniqueKey
            );
            if (projectInList && projectInList.minecraftUser) {
                selectedProject.minecraftUser = projectInList.minecraftUser;
            }
        }

        try {
            setProcessing(true);
            setError('');

            const approveResponse = await AdminService.approveProject(
                selectedProject.accountId,
                selectedProject.projectId,
                selectedProject.filename
            );

            if (!approveResponse.success) {
                throw new Error(approveResponse.message || 'Ошибка принятия проекта');
            }

            // Выдача награды в Майнкрафтии
            if (selectedProject.minecraftUser) {
                try {
                    const rewardResponse = await UserService.awardProjectReward(
                        selectedProject.minecraftUser.id,
                        selectedProject.project.diamondCount,
                        selectedProject.project.ratingCount
                    );

                    if (!rewardResponse.success) {
                        logger.warn('Проект принят, но награда не выдана:', rewardResponse.message);
                    }
                } catch (rewardError) {
                    logger.warn('Проект принят, но ошибка выдачи награды:', rewardError);
                }
            }

            setSuccessMessage(
                `Проект «${selectedProject.project.title}» принят. ` +
                `${selectedProject.student.firstName} ${selectedProject.student.lastName} ` +
                `получил награду: ${selectedProject.project.diamondCount} алмазов и ${selectedProject.project.ratingCount} рейтинга.`
            );

            closeAllModals();
            await loadProjectsForReview();
            setTimeout(() => setSuccessMessage(''), 5000);
        } catch (error) {
            logger.error('Ошибка принятия проекта:', error);
            setError('Ошибка принятия проекта: ' + error.message);
        } finally {
            setProcessing(false);
        }
    }, [selectedProject, projectsForReview, closeAllModals, loadProjectsForReview]);

    const rejectProject = useCallback(async () => {
        if (!selectedProject) return;

        try {
            setProcessing(true);
            setError('');

            const rejectResponse = await AdminService.rejectProject(
                selectedProject.accountId,
                selectedProject.projectId,
                selectedProject.filename
            );

            if (!rejectResponse.success) {
                throw new Error(rejectResponse.message || 'Ошибка отклонения проекта');
            }

            setSuccessMessage(
                `Проект «${selectedProject.project.title}» отклонён. ` +
                `${selectedProject.student.firstName} ${selectedProject.student.lastName} может сдать его заново.`
            );

            closeAllModals();
            await loadProjectsForReview();
            setTimeout(() => setSuccessMessage(''), 5000);
        } catch (error) {
            logger.error('Ошибка отклонения проекта:', error);
            setError('Ошибка отклонения проекта: ' + error.message);
        } finally {
            setProcessing(false);
        }
    }, [selectedProject, closeAllModals, loadProjectsForReview]);

    if (loading) {
        return (
            <div className={cl.page_wrapper}>
                <Spinner size="large" text="Загружаем проекты на проверку" fullPage />
            </div>
        );
    }

    if (error) {
        return (
            <div className={cl.page_wrapper}>
                <div className={cl.wrap_content_1}>
                    <div className={cl.errorState}>
                        <h3>Ошибка</h3>
                        <p>{error}</p>
                        <button onClick={loadProjectsForReview} className={cl.btnPrimary}>
                            Попробовать снова
                        </button>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div className={cl.page_wrapper}>
            <div className={cl.wrap_content_1}>
                {/* Шапка-карточка */}
                <div className={cl.pageHeader}>
                    <div className={cl.pageHeaderLeft}>
                        <div className={cl.pageHeaderIcon}>
                            <IconShieldCheck width={22} height={22}/>
                        </div>
                        <div className={cl.pageHeaderText}>
                            <div className={cl.pageHeaderTopRow}>
                                <h1 className={cl.pageHeaderTitle}>Проверка проектов</h1>
                                {projectsForReview.length > 0 && (
                                    <span className={`${cl.pageHeaderPill} ${cl.pageHeaderPillActive}`}>
                                        <span className={cl.pageHeaderPillDot}/>
                                        <span className={cl.pageHeaderPillStrong}>{projectsForReview.length}</span>
                                        <span className={cl.pageHeaderPillMuted}>
                                            {projectsForReview.length === 1 ? 'на проверке' : 'на проверке'}
                                        </span>
                                    </span>
                                )}
                            </div>
                            <div className={cl.breadcrumbs}>
                                АдминПанель · Робототехника · Проверка проектов
                            </div>
                        </div>
                    </div>
                    <div className={cl.pageHeaderActions}>
                        <button
                            onClick={loadProjectsForReview}
                            className={cl.btnGhost}
                            title="Обновить"
                        >
                            <IconRefresh width={15} height={15}/>
                        </button>
                    </div>
                </div>

                <PageIntro
                    storageKey="aprove-project"
                    title="О странице «Проверка проектов»"
                    text="Сюда приходят проекты РобоТехники, которые ученики сдали на проверку. Вы как преподаватель смотрите фото готовой работы и решаете: принять (ученик получает алмазы и рейтинг в Майнкрафтии) или отклонить (ученик сможет переделать и сдать заново)."
                    bullets={[
                        'Клик на карточку — детальный просмотр проекта с большим фото',
                        'Принятие проекта автоматически выдаёт ученику награды за этот проект',
                        'Отклонение возвращает проект ученику — он сможет переснять и пересдать',
                        'После решения проект автоматически уезжает из списка проверки',
                    ]}
                />

                {/* Тост успеха */}
                {successMessage && (
                    <div className={cl.toastSuccess}>
                        <span className={cl.toastIcon}>
                            <IconCheck width={16} height={16}/>
                        </span>
                        <span>{successMessage}</span>
                    </div>
                )}

                {projectsForReview.length === 0 ? (
                    <div className={cl.emptyState}>
                        <div className={cl.emptyIconWrap}>
                            <IconCheck width={36} height={36}/>
                        </div>
                        <h2 className={cl.emptyTitle}>Нет проектов на проверке</h2>
                        <p className={cl.emptyDescription}>
                            Пока ученики либо не сдали проекты, либо все уже проверены.
                            Загляните сюда позже.
                        </p>
                    </div>
                ) : (
                    <div className={cl.reviewGrid}>
                        {projectsForReview.map((project) => (
                            <div
                                key={project.uniqueKey}
                                className={cl.reviewCard}
                                onClick={() => openDetailModal(project)}
                            >
                                {/* Превью фото проекта */}
                                <div className={cl.reviewPhoto}>
                                    <img
                                        src={FOLDER_PROJECT_RT + project.filename}
                                        alt={project.project.title}
                                        onError={(e) => {
                                            e.target.style.display = 'none';
                                            if (e.target.nextSibling) e.target.nextSibling.style.display = 'flex';
                                        }}
                                    />
                                    <div className={cl.reviewPhotoFallback}>
                                        <IconImage width={28} height={28}/>
                                        <span>Изображение недоступно</span>
                                    </div>
                                    <div className={cl.reviewBadge}>
                                        <IconClock width={11} height={11}/>
                                        <span>На проверке</span>
                                    </div>
                                </div>

                                <div className={cl.reviewBody}>
                                    {/* Студент */}
                                    <div className={cl.reviewStudent}>
                                        <div className={cl.reviewStudentAvatar}>
                                            {project.student.firstName?.[0] || '?'}{project.student.lastName?.[0] || ''}
                                        </div>
                                        <div className={cl.reviewStudentInfo}>
                                            <div className={cl.reviewStudentName}>
                                                {project.student.firstName} {project.student.lastName}
                                                {project.student.isFallback && (
                                                    <span className={cl.fallbackHint}> · данные неполные</span>
                                                )}
                                            </div>
                                            <div className={cl.reviewStudentMeta}>
                                                {project.minecraftUser
                                                    ? `${project.minecraftUser.firstName} · Уровень ${project.minecraftUser.level}`
                                                    : `Возраст: ${project.student.age || 'не указан'}`}
                                            </div>
                                        </div>
                                        {project.minecraftUser && (
                                            <img
                                                src={project.minecraftUser.photo
                                                    ? FOLDER_PROFILE + project.minecraftUser.photo
                                                    : ava}
                                                alt=""
                                                className={cl.reviewMcAvatar}
                                                onError={(e) => { e.target.src = ava; }}
                                            />
                                        )}
                                    </div>

                                    {/* Название проекта */}
                                    <div className={cl.reviewProject}>
                                        <h4 className={cl.reviewProjectTitle}>{project.project.title}</h4>
                                        <p className={cl.reviewProjectDesc}>{project.project.desc}</p>
                                    </div>

                                    {/* Награды */}
                                    <div className={cl.reviewRewards}>
                                        <span className={cl.rewardChip}>
                                            <IconDiamond width={12} height={12}/>
                                            {project.project.diamondCount}
                                        </span>
                                        <span className={cl.rewardChip}>
                                            <IconStar width={12} height={12}/>
                                            {project.project.ratingCount}
                                        </span>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                )}
            </div>

            {/* ----- Модалка детального просмотра ----- */}
            {showDetailModal && selectedProject && (
                <div className={cl.modalOverlayV2} onClick={closeAllModals}>
                    <div className={`${cl.modalCardV2} ${cl.modalCardV2Wide}`} onClick={e => e.stopPropagation()}>
                        <header className={cl.modalCardHead}>
                            <div className={cl.modalCardTitleWrap}>
                                <span className={cl.modalCardIcon}>
                                    <IconShieldCheck width={18} height={18}/>
                                </span>
                                <h2 className={cl.modalCardTitle}>Проверка проекта</h2>
                            </div>
                            <button onClick={closeAllModals} className={cl.modalCardClose} aria-label="Закрыть">
                                <IconClose width={18} height={18}/>
                            </button>
                        </header>

                        <div className={cl.modalCardBody}>
                            <div className={cl.reviewDetailGrid}>
                                {/* Левая колонка — большое фото */}
                                <div className={cl.reviewDetailPhotoWrap}>
                                    <img
                                        src={FOLDER_PROJECT_RT + selectedProject.filename}
                                        alt={selectedProject.project.title}
                                        className={cl.reviewDetailPhoto}
                                        onError={(e) => {
                                            e.target.style.display = 'none';
                                            if (e.target.nextSibling) e.target.nextSibling.style.display = 'flex';
                                        }}
                                    />
                                    <div className={cl.reviewDetailPhotoFallback}>
                                        <IconImage width={48} height={48}/>
                                        <span>Изображение недоступно</span>
                                        <small>{selectedProject.filename}</small>
                                    </div>
                                </div>

                                {/* Правая колонка — инфо */}
                                <div className={cl.reviewDetailInfo}>
                                    {/* Студент */}
                                    <section className={cl.reviewDetailSection}>
                                        <h3 className={cl.reviewDetailSectionTitle}>
                                            <IconUser width={14} height={14}/>
                                            Ученик
                                        </h3>
                                        <div className={cl.reviewDetailStudent}>
                                            <div className={cl.reviewDetailAvatar}>
                                                {selectedProject.student.firstName?.[0] || '?'}{selectedProject.student.lastName?.[0] || ''}
                                            </div>
                                            <div>
                                                <div className={cl.reviewDetailStudentName}>
                                                    {selectedProject.student.firstName} {selectedProject.student.lastName}
                                                </div>
                                                <div className={cl.reviewDetailStudentMeta}>
                                                    Возраст: {selectedProject.student.age || 'не указан'}
                                                </div>
                                                {selectedProject.student.isFallback && (
                                                    <div className={cl.fallbackPill}>
                                                        <IconAlert width={11} height={11}/>
                                                        <span>Данные неполные</span>
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    </section>

                                    {/* Майнкрафтия */}
                                    {selectedProject.minecraftUser && (
                                        <section className={cl.reviewDetailSection}>
                                            <h3 className={cl.reviewDetailSectionTitle}>
                                                <IconBook width={14} height={14}/>
                                                Профиль Майнкрафтии
                                            </h3>
                                            <div className={cl.reviewDetailMc}>
                                                <img
                                                    src={selectedProject.minecraftUser.photo
                                                        ? FOLDER_PROFILE + selectedProject.minecraftUser.photo
                                                        : ava}
                                                    alt=""
                                                    className={cl.reviewDetailMcAvatar}
                                                    onError={(e) => { e.target.src = ava; }}
                                                />
                                                <div>
                                                    <div className={cl.reviewDetailStudentName}>
                                                        {selectedProject.minecraftUser.firstName}
                                                    </div>
                                                    <div className={cl.reviewDetailStudentMeta}>
                                                        Уровень {selectedProject.minecraftUser.level}
                                                    </div>
                                                </div>
                                            </div>
                                        </section>
                                    )}

                                    {/* Проект */}
                                    <section className={cl.reviewDetailSection}>
                                        <h3 className={cl.reviewDetailSectionTitle}>
                                            <IconBook width={14} height={14}/>
                                            Проект
                                        </h3>
                                        <h4 className={cl.reviewDetailProjectTitle}>
                                            {selectedProject.project.title}
                                        </h4>
                                        <p className={cl.reviewDetailProjectDesc}>
                                            {selectedProject.project.desc}
                                        </p>
                                    </section>

                                    {/* Награды */}
                                    <section className={cl.reviewDetailSection}>
                                        <h3 className={cl.reviewDetailSectionTitle}>
                                            <IconStar width={14} height={14}/>
                                            Награда за принятие
                                        </h3>
                                        <div className={cl.reviewDetailRewards}>
                                            <div className={cl.rewardChipBig}>
                                                <IconDiamond width={18} height={18}/>
                                                <div>
                                                    <div className={cl.rewardChipBigValue}>
                                                        {selectedProject.project.diamondCount}
                                                    </div>
                                                    <div className={cl.rewardChipBigLabel}>алмазов</div>
                                                </div>
                                            </div>
                                            <div className={cl.rewardChipBig}>
                                                <IconStar width={18} height={18}/>
                                                <div>
                                                    <div className={cl.rewardChipBigValue}>
                                                        {selectedProject.project.ratingCount}
                                                    </div>
                                                    <div className={cl.rewardChipBigLabel}>рейтинга</div>
                                                </div>
                                            </div>
                                        </div>
                                    </section>
                                </div>
                            </div>
                        </div>

                        <div className={cl.modalActionsSplitFooter}>
                            <button
                                onClick={openRejectModal}
                                className={cl.btnDanger}
                                disabled={processing}
                            >
                                <IconClose width={14} height={14}/>
                                <span>Отклонить</span>
                            </button>
                            <div className={cl.modalActionsRight}>
                                <button
                                    onClick={closeAllModals}
                                    className={cl.btnSecondary}
                                    disabled={processing}
                                >
                                    Закрыть
                                </button>
                                <button
                                    onClick={openApproveModal}
                                    className={cl.btnSuccess}
                                    disabled={processing}
                                >
                                    <IconCheck width={14} height={14}/>
                                    <span>Принять проект</span>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {/* ----- Подтверждение принятия ----- */}
            {showApproveModal && selectedProject && (
                <div className={cl.modalOverlayV2} onClick={closeAllModals}>
                    <div className={cl.modalCardV2} onClick={e => e.stopPropagation()}>
                        <header className={cl.modalCardHead}>
                            <div className={cl.modalCardTitleWrap}>
                                <span className={`${cl.modalCardIcon} ${cl.modalCardIconSuccess}`}>
                                    <IconCheck width={18} height={18}/>
                                </span>
                                <h2 className={cl.modalCardTitle}>Принять проект?</h2>
                            </div>
                            <button onClick={closeAllModals} className={cl.modalCardClose} aria-label="Закрыть">
                                <IconClose width={18} height={18}/>
                            </button>
                        </header>
                        <div className={cl.modalCardBody}>
                            <div className={cl.confirmBody}>
                                <p className={cl.confirmText}>
                                    Принять проект <strong>«{selectedProject.project.title}»</strong>?
                                </p>
                                <p className={cl.confirmHint}>
                                    Ученик {selectedProject.student.firstName} {selectedProject.student.lastName} получит награду:
                                </p>
                                <div className={cl.reviewDetailRewards}>
                                    <div className={cl.rewardChipBig}>
                                        <IconDiamond width={16} height={16}/>
                                        <div>
                                            <div className={cl.rewardChipBigValue}>{selectedProject.project.diamondCount}</div>
                                            <div className={cl.rewardChipBigLabel}>алмазов</div>
                                        </div>
                                    </div>
                                    <div className={cl.rewardChipBig}>
                                        <IconStar width={16} height={16}/>
                                        <div>
                                            <div className={cl.rewardChipBigValue}>{selectedProject.project.ratingCount}</div>
                                            <div className={cl.rewardChipBigLabel}>рейтинга</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className={cl.modalActionsFooter}>
                            <button onClick={closeAllModals} className={cl.btnSecondary} disabled={processing}>
                                Отмена
                            </button>
                            <button onClick={approveProject} className={cl.btnSuccess} disabled={processing}>
                                {processing ? 'Обработка…' : 'Да, принять'}
                            </button>
                        </div>
                    </div>
                </div>
            )}

            {/* ----- Подтверждение отклонения ----- */}
            {showRejectModal && selectedProject && (
                <div className={cl.modalOverlayV2} onClick={closeAllModals}>
                    <div className={cl.modalCardV2} onClick={e => e.stopPropagation()}>
                        <header className={cl.modalCardHead}>
                            <div className={cl.modalCardTitleWrap}>
                                <span className={`${cl.modalCardIcon} ${cl.modalCardIconDanger}`}>
                                    <IconAlert width={18} height={18}/>
                                </span>
                                <h2 className={cl.modalCardTitle}>Отклонить проект?</h2>
                            </div>
                            <button onClick={closeAllModals} className={cl.modalCardClose} aria-label="Закрыть">
                                <IconClose width={18} height={18}/>
                            </button>
                        </header>
                        <div className={cl.modalCardBody}>
                            <div className={cl.confirmBody}>
                                <p className={cl.confirmText}>
                                    Отклонить проект <strong>«{selectedProject.project.title}»</strong>?
                                </p>
                                <p className={cl.confirmHint}>
                                    Ученик {selectedProject.student.firstName} {selectedProject.student.lastName} сможет сдать его заново.
                                    Это действие нельзя будет отменить.
                                </p>
                            </div>
                        </div>
                        <div className={cl.modalActionsFooter}>
                            <button onClick={closeAllModals} className={cl.btnSecondary} disabled={processing}>
                                Отмена
                            </button>
                            <button onClick={rejectProject} className={cl.btnDangerSolid} disabled={processing}>
                                {processing ? 'Обработка…' : 'Да, отклонить'}
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default AproveProject;
